import styled from 'styled-components'
import { MediaBreakPointUp } from '~/theme'

export const StyledMainInputContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: 56px;
  padding: 3px;
  align-items: center;
  min-height: 64px;
  overflow: hidden;
`

export const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 20px;
  flex: 1;
  overflow: hidden;
`

export const StyledInput = styled.input`
  width: 100%;
  border: none;
  color: ${({ theme }) => theme.colors.textTitle};
  outline: none;
  background: transparent;
  text-align: right;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  padding-right: 0;
  ::placeholder {
    color: ${({ theme }) => theme.colors.textPlaceholder};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */

  -moz-appearance: textfield;
`

export const StyledInputValue = styled.div`
  color: ${({ theme }) => theme.colors.textCaption};
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
  text-align: right;
  max-width: 270px;

  @media screen and (max-width: ${MediaBreakPointUp.sm}) {
    max-width: 220px;
  }
`
